// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CreateWalletModal.module.css */

/* Фон модалки */
.CreateWalletModal_modalBackdrop__IichW {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Содержимое модалки */
.CreateWalletModal_modalContent__FtmIX {
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 15px;
  width: 450px;
  max-width: 90%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: CreateWalletModal_fadeIn__SUU1p 0.3s ease;
}

/* Анимация появления */
@keyframes CreateWalletModal_fadeIn__SUU1p {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Заголовок модалки */
.CreateWalletModal_headText__D2tQF {
  margin-bottom: 20px;
  color: rgba(24, 115, 70, 1);
  text-align: center;
  font-size: 1.6rem;
  font-weight: 600;
}

/* Поля ввода */
.CreateWalletModal_field__EfphE {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.CreateWalletModal_field__EfphE label {
  margin-bottom: 6px;
  font-weight: 500;
  color: rgba(24, 115, 70, 1);
}

.CreateWalletModal_field__EfphE input {
  padding: 10px 12px;
  border: 1.5px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.CreateWalletModal_field__EfphE input:focus {
  border-color: rgba(24, 115, 70, 1);
  outline: none;
}

/* Сообщение об ошибке */
.CreateWalletModal_error__JPAtU {
  color: #d32f2f;
  font-size: 0.85rem;
  margin-top: 4px;
}

/* Кнопки */
.CreateWalletModal_buttons__0F\\+I5 {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.CreateWalletModal_buttons__0F\\+I5 button {
  padding: 10px 22px;
  border-radius: 8px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.CreateWalletModal_buttons__0F\\+I5 button:first-child {
  background-color: #ccc;
  color: #fff;
}

.CreateWalletModal_buttons__0F\\+I5 button:first-child:hover {
  background-color: #b3b3b3;
}

.CreateWalletModal_buttons__0F\\+I5 button:last-child {
  background-color: rgba(24, 115, 70, 1);
  color: #fff;
}

.CreateWalletModal_buttons__0F\\+I5 button:last-child:hover {
  background-color: rgba(24, 115, 70, 0.8);
}

.CreateWalletModal_buttons__0F\\+I5 button:disabled {
  background-color: #999;
  cursor: not-allowed;
}

/* Кнопка закрытия */
.CreateWalletModal_closeBtn__11DjG {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 1.4rem;
  color: rgba(24, 115, 70, 1);
  cursor: pointer;
  transition: color 0.2s;
}

.CreateWalletModal_closeBtn__11DjG:hover {
  color: rgba(24, 115, 70, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/pages/FinanceView/modal/CreateWalletModal.module.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,oDAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* CreateWalletModal.module.css */\n\n/* Фон модалки */\n.modalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n/* Содержимое модалки */\n.modalContent {\n  background-color: #fff;\n  padding: 30px 40px;\n  border-radius: 15px;\n  width: 450px;\n  max-width: 90%;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  position: relative;\n  animation: fadeIn 0.3s ease;\n}\n\n/* Анимация появления */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Заголовок модалки */\n.headText {\n  margin-bottom: 20px;\n  color: rgba(24, 115, 70, 1);\n  text-align: center;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n/* Поля ввода */\n.field {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.field label {\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: rgba(24, 115, 70, 1);\n}\n\n.field input {\n  padding: 10px 12px;\n  border: 1.5px solid #ccc;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.field input:focus {\n  border-color: rgba(24, 115, 70, 1);\n  outline: none;\n}\n\n/* Сообщение об ошибке */\n.error {\n  color: #d32f2f;\n  font-size: 0.85rem;\n  margin-top: 4px;\n}\n\n/* Кнопки */\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.buttons button {\n  padding: 10px 22px;\n  border-radius: 8px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.buttons button:first-child {\n  background-color: #ccc;\n  color: #fff;\n}\n\n.buttons button:first-child:hover {\n  background-color: #b3b3b3;\n}\n\n.buttons button:last-child {\n  background-color: rgba(24, 115, 70, 1);\n  color: #fff;\n}\n\n.buttons button:last-child:hover {\n  background-color: rgba(24, 115, 70, 0.8);\n}\n\n.buttons button:disabled {\n  background-color: #999;\n  cursor: not-allowed;\n}\n\n/* Кнопка закрытия */\n.closeBtn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  font-size: 1.4rem;\n  color: rgba(24, 115, 70, 1);\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.closeBtn:hover {\n  color: rgba(24, 115, 70, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `CreateWalletModal_modalBackdrop__IichW`,
	"modalContent": `CreateWalletModal_modalContent__FtmIX`,
	"fadeIn": `CreateWalletModal_fadeIn__SUU1p`,
	"headText": `CreateWalletModal_headText__D2tQF`,
	"field": `CreateWalletModal_field__EfphE`,
	"error": `CreateWalletModal_error__JPAtU`,
	"buttons": `CreateWalletModal_buttons__0F+I5`,
	"closeBtn": `CreateWalletModal_closeBtn__11DjG`
};
export default ___CSS_LOADER_EXPORT___;
